import { render, staticRenderFns } from "./InfoTypeCountsModal.vue?vue&type=template&id=59ccc742&"
import script from "./InfoTypeCountsModal.vue?vue&type=script&lang=ts&"
export * from "./InfoTypeCountsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports